export const CLIENT_VAL_PASS = "CLIENT_VAL_PASS";
export const CLIENT_VAL_PASS_ERROR = "CLIENT_VAL_PASS_ERROR";
export const CLIENT_VAL_PASS_HIDE_ERROR = "CLIENT_VAL_PASS_HIDE_ERROR";
export const CLIENT_VAL_PASS_START_LOADER = "CLIENT_VAL_PASS_START_LOADER";
export const CLIENT_VAL_PASS_STOP_LOADER = "CLIENT_VAL_PASS_STOP_LOADER";
